module.exports = __webpack_public_path__ + "img/7.649adbc4.jpg";